import React from 'react';
import { Card } from "react-bootstrap";
import face_christopher_stapenhurst from "../../assets/img/face_christopher_stapenhurst.jpg";
import ShowMoreText from "react-show-more-text";
import proj_stable_coop from "../../assets/img/proj_stable_coop.png";

const Chris_Stapenhurst_stable_coop = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_stable_coop} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_christopher_stapenhurst}
              /* this will be the text on the banner */
              alt="Stable Cooperation in Network Games"
            />{" "}
            <p className="text7">Christopher Stapenhurst</p>
            <br />
            <p className="text8">
              Postdoctoral Researcher{" "}
            </p>
            <p className="text8">QSMS Research Group, BME</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            A network game is one where each player's payoff is affected only by the actions of 
            their neighbours in the network. Players may be able to improve their collective 
            payoff by committing to work together, but only if they can share the benefits of 
            cooperation in such a way that no subset of players can do better by writing their 
            own agreement. The goal of this project is to study the relationship between the 
            shape of the network and the existence of a stable agreement. The ideal student must 
            be comfortable with optimisation techniques. Knowledge of cooperative game theory 
            and/or graph theory and/or integer partitions is good, but not strictly necessary. 
            For an example of a network game with cooperation, <a href="https://drive.google.com/file/d/1XUDSSkWRtjaLwIxeh4EIS-FrZj1naun4/view">see</a>.


            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Chris_Stapenhurst_stable_coop;